module.exports = __webpack_public_path__ + "img/bank.eb60c52b.png";